import { render } from "./edit.vue?vue&type=template&id=6bfc2ee8&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=6bfc2ee8&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfc2ee8"],['__file',"src/views/room/roomPriceCode/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bfc2ee8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bfc2ee8', __exports__)) {
    console.log('reload')
    api.reload('6bfc2ee8', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=6bfc2ee8&scoped=true", () => {
    console.log('re-render')
    api.rerender('6bfc2ee8', render)
  })

}


export default __exports__